import axiosInstance from "./config";
import {
  ICourierCreate,
  ICourierServiceCreate,
} from "views/admin/couriers/types/courier.interface";

const basePath = `/induk-app/couriers`;
const subBasePath = `${basePath}/courier-service`;

export const getCouriers = () => {
  return axiosInstance.get(`${basePath}`);
};

export const addCourier = (payload: ICourierCreate) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value as string);
  });

  return axiosInstance.post(`${basePath}/create`, formData);
};

export const getCourier = (id: string) => {
  return axiosInstance.get(`${basePath}/${id}`);
};

export const updateCourier = (id: string, courier: Partial<ICourierCreate>) => {
  const formData = new FormData();
  Object.entries(courier).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value as string);
  });

  return axiosInstance.patch(`${basePath}/${id}/update`, formData);
};

export const deleteCourier = (id: number) => {
  return axiosInstance.delete(`${basePath}/${id}/delete`);
};

export const getCourierServices = (id: number) => {
  return axiosInstance.get(`${subBasePath}/${id}/services`);
};

export const addCourierService = (
  courierId: number,
  payload: ICourierServiceCreate
) => {
  return axiosInstance.post(
    `${subBasePath}/${courierId}/services/create`,
    payload
  );
};

export const removeCourierService = (courierId: number, serviceId: number) => {
  return axiosInstance.delete(
    `${subBasePath}/${courierId}/services/${serviceId}/remove`
  );
};

export const updateCourierService = (
  courierId: number,
  serviceId: number,
  payload: ICourierServiceCreate
) => {
  return axiosInstance.patch(
    `${subBasePath}/${courierId}/services/${serviceId}/update`,
    payload
  );
};
